export default {
  shareMeta: {
    title: "Foto de <xx1> no PixelHaha",
    description:
      "Baixe esta foto gratuita criada por <xx1> usando o gerador de imagens de IA no PixelHaha.",
  },
  home: {
    picTitle: "Banco de imagens gratuitas",
    recentSearch: "Pesquisas recentes",
    clear: "claro",
    trendsSearch: "Pesquisas em alta",
    details: "Detalhes",
    enhance: "Melhorar",
    reimagine: "Reimaginar",
  },
  search: {
    guess: "Pode também gostar",
    trending: "Tendências",
    newest: "Mais novo",
    empty: "Ainda não há resultados de pesquisa.",
    goCreate: "Vá criar a imagem",
    searchPlaceholder: "A inspiração começa aqui...",
  },
  detail: {
    report: "Relatório",
    downloadFree: "Baixar grátis",
    prompt: "Incitar",
    more: "Pode também gostar",
    toCreate: "Criar",
    enhance: "Melhorar foto",
    invalid:
      "Link desempregado. Criador cancelado publicação ou imagem não compatível.",
    generation:
      "O PixelHaha oferece geração de imagens de alta qualidade para você.",
    exploreMore: "Explorar mais",
    jpg: "JPG",
    png: "PNG",
    download : "O download falhou. Verifique sua conexão de rede e tente novamente.",
  },
  trends: {
    bgTip: "Pesquisas em alta",
    wrong: "Algo deu errado",
    retry: "Tentar novamente",
    top: "Topo",
    a: "A",
    b: "B",
    c: "C",
    d: "D",
    e: "E",
    f: "F",
    g: "G",
    h: "H",
    i: "I",
    j: "J",
    k: "K",
    l: "L",
    m: "M",
    n: "N",
    o: "O",
    p: "P",
    q: "Q",
    r: "R",
    s: "S",
    t: "T",
    u: "U",
    v: "V",
    w: "W",
    x: "X",
    y: "Y",
    z: "Z",
  },
  img: {
    notReviewed: "Esta imagem não foi revisada",
    posting: "Postando...",
    deleteQ: "confirmar exclusão?",
    cancel: "Cancelar",
    delete: "Excluir",
  },
  ugcPage: {
    editName: "Editar Nome",
    finish: "Terminar",
    goHistory: "Ir para histórico publicar",
    tabWork: "Trabalhar",
    tabFavorites: "Favoritos",
    empty: "Nenhum dado",
    avatarTypeError: "Somente .png, .jpg, .webp suportados",
  },
  siteMap: {
    page: "Página",
    sort: "Organizar",
    keywords: "Palavras-chave",
  },
  report: {
    title: "Denunciar conteúdo",
    text: "Por que você está relatando isso?",
    reason1: "Violação dos Termos de Uso",
    reason2: "Baixa qualidade",
    reason3: "Spam",
    reason4: "Conteúdo sensível",
    reason5: "Outro",
    textplaceholder:
      "Descreva os problemas que você encontrou, sendo o mais específico possível.",
    submit: "Confirmar Relatório",
    toastSuccess: "Relatório enviado com sucesso. Nós o revisaremos em breve.",
    toastFailed: "Falha ao enviar o relatório, tente novamente.",
  },
};
